/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { albumCollectionItemModelSchema } from "./albumCollectionItemModelSchema.ts";
import { albumCollectionTypeEnumSchema } from "./albumCollectionTypeEnumSchema.ts";
import { authorAlbumCollectionModelSchema } from "./authorAlbumCollectionModelSchema.ts";
import { fileModelSchema } from "./fileModelSchema.ts";
import { z } from "zod";

export const albumCollectionInfoModelSchema = z.object({
    "id": z.string().uuid().describe("Идентификатор"),
"name": z.string().describe("Название"),
"description": z.string().describe("Описание").nullable().nullish(),
"picture": z.lazy(() => fileModelSchema).describe("Обложка").nullable().nullish(),
"authors": z.array(z.lazy(() => authorAlbumCollectionModelSchema)).describe("Авторы"),
"type": z.lazy(() => albumCollectionTypeEnumSchema).describe("<p>Возможные значения:</p>\n<ul>\n<li><b>1 - Music</b>: Музыкальный выпуск</li>\n<li><b>2 - Podcast</b>: Выпуск подкастов</li>\n<li><b>3 - Book</b>: Выпуск книг</li>\n<li><b>4 - Sermon</b>: Выпуск проповедей</li>\n</ul>\n"),
"albums": z.array(z.lazy(() => albumCollectionItemModelSchema)).describe("Альбомы").nullable().nullish()
    })